export default __webpack_public_path__ + "static/media/icon-coin-pyth.5499fb54.svg";